import PropTypes from 'prop-types'
import numeral from 'numeral'
import React from 'react'

const SubscriptionPriceToken = ({ period }) => (
  <div className="subscriptions-price-token">
    <table className="ui celled compact unstackable table">
      <thead>
        <tr>
          <th>Item</th>
          <th className="collapsing">Price</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>{ period.plan.line_item_description  }</td>
          <td className="right aligned">{ numeral(period.price).format('0.00') }</td>
        </tr>
        { period.addons.map((addon, index) => (
          <tr key={`addon_${index}`}>
            <td>{ addon.title }</td>
            <td className="right aligned">{ numeral(addon.price).format('0.00') }</td>
          </tr>
        ))}
      </tbody>
      <tfoot>
        <tr>
          <th>Total</th>
          <td className="right aligned">{ numeral(period.addons.reduce((total, addon) => {
            return total + Number(addon.price)
          }, Number(period.price))).format('0.00') }</td>
        </tr>
      </tfoot>
    </table>
  </div>
)

SubscriptionPriceToken.propTypes = {
  period: PropTypes.object
}

export default SubscriptionPriceToken
